export default "__VITE_ASSET__D9jtxs4C__"